export default __webpack_public_path__ + "static/media/giglio.f9f78185.png";